<template>
    <v-layout v-if="store.state.user.token&&groupe.find(g=>g==store.state.user.groupe)">
        <v-table>
            <tbody>
                <tr>
                    <td>
                        <v-navigation-drawer>
                            <v-card>
                                <v-overlay v-model="store.state.waiting"></v-overlay>
                                <v-list-item title="Liste de réceptions" subtitle="Vuetify"></v-list-item>
                                <v-row >
                                    <v-checkbox label="Encours" v-model="inProgress" @change="finished=false;getReceptions()" style="margin-left: 1em;"></v-checkbox>
                                    <v-checkbox label="Terminé" v-model="finished" @change="inProgress=false;accepted=false;denied=false;getReceptions()"></v-checkbox> 
                                </v-row>
                                 <v-row style="margin-top: -30px;" v-if="inProgress">
                                    <v-checkbox label="ATT" v-model="attente" @change="finished=false;accepted=false;denied=false;getReceptions();" style="margin-left: 1em;"></v-checkbox> 
                                    <v-checkbox label="OK" v-model="accepted" @change="finished=false;attente=false;denied=false;getReceptions()"></v-checkbox>
                                    <v-checkbox label="KO" v-model="denied" @change="finished=false;attente=false;accepted=false;getReceptions()"></v-checkbox> 
                                </v-row> 
                                <v-row style="margin-top: -30px;">
                                    <v-text-field
                                        v-model="rechercher"
                                        label="Rechercher"
                                        variant="outlined" 
                                        density="compact"
                                        style="margin: 20px;"
                                    ></v-text-field>
                                </v-row>
                                
                                <v-list>
                                    <v-divider></v-divider>
                                    <v-list-item 
                                        v-for="(item, i) in listeReceptions"
                                        :key="i"
                                        :value="item"
                                        color="primary"
                                        variant="plain"
                                        @click="getReception(item,i);selected=true"
                                    >
                                    <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 200px;">
                                        <span>{{ item.title}}</span><br>
                                        <span v-if="item.reception.informations" :style="[(item.reception.informations.match(/ref/gmi)||item.reception.etat.match(/ref/gmi))?{'color':'red'}:{'color':'green'}]">
                                            {{ `${item.reception.informations?''+item.reception.informations:''}`}}
                                        </span> 
                                    </button>
                                </v-list-item>
                                </v-list>
                            </v-card> 
                        </v-navigation-drawer>
                    </td>
                    <td  >
                        <v-main  >
                            <div class="container" style="margin-top: 50px;min-width: 1200px;" >
                            <v-expansion-panels
                            v-model="panel"
                            :disabled="disabled"
                            multiple
                            >
                                <v-expansion-panel >
                                    <v-expansion-panel-title color="primary">
                                        <template v-slot:actions="{ expanded }">
                                            <v-btn 
                                            @click.stop="dialogStatsTiers=true"
                                            variant="tonal"
                                            size="small"
                                            class="mr-2"
                                            icon="mdi-google-analytics"
                                            >
                                            </v-btn>
                                            <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
                                        </template>
                                        
                                        <!-- Contenu du titre -->
                                        <span>Réception</span>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                        <div v-if="selected">
                                            <v-row >
                                                <v-col cols="12"  md="1">
                                                    <v-text-field  v-model="reception.etablissement" label="Magasin" disabled variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                <v-col cols="12"  md="1">
                                                    <v-text-field v-model="reception.numeroBon" label="Numéro" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field  v-model="reception.date.split('T')[0]" label="Date" disabled variant="outlined" density="compact"></v-text-field> 
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.vendeur" label="Vendeuse/Vendeur" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="3">
                                                    <v-combobox  v-model="reception.etat" label="Status" :items="itemsStatus" :disabled="reception&&termine" variant="outlined" density="compact"></v-combobox>
                                                </v-col> 
                                                <v-col cols="12"  md="3">
                                                    <v-text-field v-model="reception.informations" label="Motif" :disabled="reception&&termine||!reception.etat.match(/refus/gmi)"
                                                     variant="outlined" density="compact"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12" md="1">
                                                    <v-text-field  v-model="reception.ticket" label="Ticket?" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.bonAchat" label="Bon Achat" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field  v-model="reception.choixReprise" label="Choix Reprise" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">Articles</v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                        <v-table v-if="selected">
                                            <thead >
                                                <tr >
                                                    <th v-for="item in headers"
                                                        :key="item.name">{{ item.title }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="selected">
                                                <tr
                                                    v-for="item in articles"
                                                    :key="item"
                                                >
                                                    <td>{{ item.marque }}</td> 
                                                    <td>{{ item.theme }}</td>
                                                    <td>
                                                        <select @change="modifier($event.target.value,title,item.id,'grade')"> 
                                                            <option > {{ item.grade }}
                                                            </option>
                                                            <option v-for="el in itemsGrade" >{{ el }}
                                                            </option>
                                                        </select>
                                                    </td>
                                                    <td>{{ item.composition }}</td>
                                                    <td>€<input type="text"  :value="item.prixPublicTTC!=0?item.prixPublicTTC:''" :style="[item.prixPublicTTC!=0?{'text-align': 'center' ,'size':3}:{'background-color':'pink','text-align': 'center' ,'size':3}]" style="text-align: center;" size="3" @change="modifier($event.target.value,title,item.id,'prixPublicTTC')"></td>
                                                    <td>{{ item.sousFamille }}</td>
                                                    <td>{{ item.libCouleur }}</td>
                                                    <td >€{{ item.prixAchatHT }}</td>
                                                    <td>€{{ item.prixAchatOrigine }}</td>
                                                    <td><input type="text"  :value="item.qteCommande" style="text-align: center;" size="2" @change="modifier($event.target.value,title,item.id,'qteCommande')"> </td>
                                                    <td><ul ><li v-for="el in item.accessoires">{{ el }}</li></ul></td>
                                                    <td>{{ item.poidnet }}</td>
                                                    <td>{{ item.dimensions }}</td>
                                                    <td>{{ item.remarque }}</td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                        <div v-if="photos.photos">
                                            <table>
                                                <tbody>
                                                    <tr> 
                                                        <td>
                                                            <button style="margin-left: 5px;"  @click="getPhotos(`signature_${reception.etablissement}-${reception.numeroBon}.png`)" type="button" class="btn btn-outline-secondary btn-sm">Signature</button>
                                                        </td>
                                                        <td v-for="(el, index) in photos.photos">
                                                            <button v-if="el!=''"  style="margin-left: 5px;"  @click="getPhotos(el)" type="button" class="btn btn-outline-secondary btn-sm">Photo {{ index }}</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table> 
                                        </div>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">Client</v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                            <v-row>
                                                <v-checkbox :label="bonReception.client.sexe" v-model="checked" style="margin-left: 1em;" disabled></v-checkbox>
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col  cols="12" md="2">
                                                    <v-text-field  v-model="bonReception.client.firstname" label="Prénom" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" md="2" >
                                                    <v-text-field v-model="bonReception.client.lastname" label="Nom" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="bonReception.client.birdhDay" label="Date de naissance" disabled variant="outlined" density="compact"
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.telephone" label="Téléphone" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="3">
                                                    <v-text-field v-model="bonReception.client.email" label="E-mail" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.pays" label="Pays" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12"  md="2">
                                                    <v-text-field v-model="bonReception.client.codePostal" label="Code Postal" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="bonReception.client.ville" label="Ville" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                            </v-row>
                                            <v-row style="margin-top: -30px;">
                                                <v-col cols="12"  md="5">
                                                    <v-text-field v-model="bonReception.client.adresse" label="Adresse" disabled variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                            </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel>
                                    <v-expansion-panel-title color="primary">Emailing</v-expansion-panel-title>
                                    <v-expansion-panel-text v-if="selected">
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field v-model="bonReception.client.email" label="E-mail" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                <v-col cols="12" md="2">
                                                    <v-text-field v-model="reception.prenom" label="Prénom" variant="outlined" density="compact"></v-text-field>
                                                </v-col> 
                                                
                                                <v-col cols="12" md="1">
                                                    <v-btn :text="attente?'Relancer':'E-mail'" :color="attente?'warning':'success'" @click="reSendEmail()"></v-btn>
                                                </v-col> 
                                            </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                            </v-expansion-panels>
                            <v-dialog  width="500">
                                <template v-slot:activator="{ props: activatorProps }">
                                    <v-btn v-if="reception"
                                    v-bind="activatorProps"
                                    color="success"
                                    text="Valider"
                                    variant="flat"
                                    :disabled="etat()"
                                    block
                                    ></v-btn>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card title="Validation">
                                    <v-card-text>
                                        Vous voulez vraiment valider la reception?
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <input :rules="rules(mdpSaisie)" :style="[mdpSaisie==mdp?{'color':'green'}:{'background-color':'pink','color':'red'}]"
                                        type="text" class="form-control" placeholder="mot de passe" aria-label="mot de passe" aria-describedby="basic-addon2" v-model="mdpSaisie">
                                        <v-btn
                                        text="Annuler"
                                        @click="isActive.value = false"
                                        color="warning"
                                        ></v-btn>
                                        <v-btn
                                        text="Terminer"
                                        @click="isActive.value = false;validerReception()"
                                        :disabled="mdpSaisie===mdp?false:true"
                                        color="success"
                                        ></v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>
                            <div class="text-center pa-4">

                                <v-dialog
                                    v-model="dialogEmail"
                                    width="auto"
                                >
                                    <v-card
                                    max-width="400"
                                    prepend-icon="mdi-update"
                                    :text="`Le dernier email a été renvoyé`"
                                    title="Email envoyé"
                                    >
                                    <template v-slot:actions>
                                        <v-btn
                                        class="ms-auto"
                                        text="Ok"
                                        @click="dialogEmail = false"
                                        ></v-btn>
                                    </template>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </div>
                        </v-main>

                    </td>
                </tr>
            </tbody>
        </v-table>
    </v-layout>
    <div class="text-center pa-4">
      <v-dialog v-model="imageDialog" width="600">
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
     <v-dialog
        v-model="dialogStatsTiers"
        width="auto"
        persistent
    >
        <v-card
        prepend-icon="'mdi-google-analytics"
        title="Statistiques Second Life"
        >
        <v-card-text>
            <div width="900px">
                <table>
                    <tbody>
                        <tr>
                            <!-- <v-btn density="compact" @click="statsToGet='all';dialogueFiltre=true" icon="mdi-plus" style="margin-top: 15px;" ></v-btn> -->
                            <td width="150px">
                                <v-select  
                                variant="outlined"
                                :items="['etablissement','marque','code_sousfamille','designation','code_famille','famille','couleur','statut','grade']"
                                density="compact"
                                label="Axe X"
                                v-model="axe.x"
                                ></v-select>
                            </td>
                            <td width="150px" style="margin-left: 10px;">
                                <v-select
                                    variant="outlined"
                                    :items="['achat_euro','vte_euro','qte']"
                                    density="compact"
                                    label="Axe Y"
                                    v-model="axe.y"
                                ></v-select>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                            </td>
                            <!-- <td width="160px" style="margin-left: 10px;"> 
                                <v-text-field :disabled="authorized.modif" density="compact" v-model="filtreSingleParams.gp_tiers" label="Code Client" type="text" variant="outlined" clearable></v-text-field>
                            </td>
                            <td width="160px" style="margin-left:10px;">
                                <v-combobox clearable    chips    multiple
                                    label="Saison"
                                    :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                    v-model="filtreSingleParams.gp_librepiece3"
                                    variant="outlined" density="compact"
                                ></v-combobox>
                            </td> -->
                            <!-- <v-btn style="margin-top: 15px;margin-left: 10px;"
                                density="compact"
                                :loading="loading"
                                :disabled="!filtreSingleParams.gp_tiers&&!filtreSingleParams.gp_librepiece3"
                                @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                                aria-label="Refresh"
                                icon="mdi-refresh"
                            ></v-btn>
                            <v-btn  density="compact" style="margin-top: 15px;;margin-left: 10px;" color="green" @click="exportToExcel(statsTable)" >
                                <v-icon icon="mdi-file-excel"></v-icon>
                            </v-btn> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div   class="chart-chart-container-pie">
                <div style="height: 400px">
                    <Pie  v-if="!isBarChart" :data="chartDataStats" :options="pieOptions" />
                    <Bar  v-if="isBarChart" :data="chartDataStats" :options="barOptions" />
                </div>
            </div>
        </v-card-text>
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogStatsTiers = false"
                ></v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { ref,watch } from 'vue';
import store from './store';
import { onMounted, computed } from 'vue';
import axios from 'axios';
import {
    Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale 
    } from 'chart.js'
    import { Pie, Bar } from 'vue-chartjs'

let rechercher=ref()
let grapheType=ref()
let listeReceptions=ref(store.state.listeReceptions.receptions.sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon}))
watch(rechercher,()=>{
    let regex = new RegExp(rechercher.value, "i")
     listeReceptions.value=store.state.listeReceptions.receptions.filter(el=>(`${el.title}${el.reception.informations?'-'+el.reception.informations:''}`).match(regex)).sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon})
})
const modifier=(value,title,id,champs)=>{
    store.commit('editRowArticleReception',{'value':value,'title':title,'id':id,'champs':champs})
}
let etat=()=>{

    return (reception.value&&(reception.value.etat.match(/cours/gmi)||(reception.value.etat.match(/proposition/gmi)&&articles.value[0].prixAchatHT==0)||(reception.value.etat.match(/valid/gmi)&&reception.value.ticket.match(/non/gmi))||termine.value||(!reception.value.etat.match(/REFUS_CLIENT/gmi)&&reception.value.etat.match(/refus/gmi)&&(reception.value.informations==''||reception.value.informations==null))))?true:false
}
let dialogEmail=ref(false)
let groupe=ref(['A','B'])
let panel=ref( [0, 1])
let itemtoDelete=ref()
let imageDialog=ref(false)
let srcImage=ref()
let itemsGrade=ref(['A','B','C'])
let articles=ref()
let itemsStatus=ref(['En cours','Refusé','Validé','Proposition'])
let bonReception=ref()
let title=ref()
let mdpSaisie=ref()
let dialogStatsTiers=ref(false)
let axe=ref({
        x:'etablissement',
        y:'qte',
        showPercent:false
    })
const isBarChart = ref(false)
let headers=ref([
    { key: 'marque',title: 'Marque'},
    { key: 'theme', title: 'Thème' },
    { key: 'grade', title: 'Grade' },
    // { key: 'refFourn', title: 'Ref_fourn' },
    { key: 'composition', title: 'Composition' },
    { key: 'prixPublicTTC', title: 'Prix_TTC' },
    { key: 'sousFamille', title: 'Sous_Famille' },
    { key: 'libCouleur', title: 'Couleur' },
    { key: 'prixAchatHT', title: 'Prix_Reprise' },
    { key: 'prixAchatOrigine', title: 'Prix_Origine' },
    { key: 'qteCommande', title: 'Qte' },
    { key: 'accessoires', title: 'Acessoires' },
    { key: 'poidnet', title: 'PoidsNet' },
    { key: 'dimensions', title: 'Dimensions_L*H*P' },
    { key: 'remarque', title: 'Remarque_acheteur' }
    // ,
    // { key: 'totalBrut', title: 'Total_Brut' } 
    ]) 
let photos=ref()
const supprimer=(item)=>{
    itemtoDelete=item
}
let inProgress=ref(false)
let finished=ref(false)
let accepted=ref(false)
let attente=ref(false)
let denied=ref(false)
let reception=ref()
let checked=ref(true)
let disabled=ref(false)
let deleteDialog=ref(false)
let selected=ref(false)
let photo=ref()
let termine=ref()
const mdp=ref('fripe')

const sum=(object,value)=>{
    let sum=0
    for(let key in object){
        sum=sum+(object[key][value]?Number(object[key][value]):0)
    } 
    return sum
    } 
let rules=(value)=>{
    if (value===mdp.value){
        return [true]
      } else{
        return [`Mot de passe n'est pas correcte`]
      }
  }
const getReception=(item,i)=>{
    photo.value=''
    bonReception.value=item
    articles.value=bonReception.value.articles
    reception.value=bonReception.value.reception
    photos.value=bonReception.value.photos
    photos.value.photos
    termine.value=bonReception.value.termine
    title.value=bonReception.value.title
    
}
function getReceptions(){  
    store.commit('updateWaiting')  
    let url=    `https://my.edisac.com/api/receptions`
    let config = {
    method: 'get',
    url: url,
    params:{finished:finished.value,inprogress:inProgress.value,attente:attente.value,accepted:accepted.value,denied:denied.value}
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('addListeReceptions',response.data)
        statsTable.value=response.data
        statsTableFiltred.value=response.data
        listeReceptions.value=store.state.listeReceptions.receptions.sort((a,b)=>{return b.reception.numeroBon-a.reception.numeroBon})
        store.commit('updateWaiting')  

    })
    .catch((error) => {
    console.log(error);
    });
}
const chartDataStats = computed(() => {
            const data = chartData2()
            return {
                labels: data.tabTheme,
                datasets: [{
                label: `Données ${axe.value.showPercent?'% ':''}`,
                data: data.tabQte,
                backgroundColor: data.colorTab
                }]
            }
        })

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'right' }
        }
    }

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: { beginAtZero: true }
        }
    }
    let statsTable=ref([])
    let statsTableFiltred=ref([])
    function chartData2() {
        const qte = { autre: 0 };
        const colorTab = [generateRandomColor()];
        let sum = 0;
        
        const data = statsTableFiltred.value.data;
        
        
        // Traitement unique
        Object.values(data).forEach(item => {
            if (!item || item[axe.value.x] === undefined) return;
            if(item[axe.value.x] ){
                const xVal = item[axe.value.x].toString();
                const yVal = Number(item[axe.value.y]) || 0;
                
                if (!xVal) {
                    qte.autre += yVal;
                } else {
                    if (!qte[xVal]) {
                        colorTab.push(generateRandomColor());
                        qte[xVal] = yVal;
                    } else {
                        qte[xVal] += yVal;
                    }
                }
                sum += yVal;
            }
            
        });
        
        // Nettoyage et retour
        if (qte.autre === 0) {
            delete qte.autre;
            colorTab.shift();
        }
        
        const tabTheme = Object.keys(qte);
        let tabQte = Object.values(qte);
        
        if (axe.value.showPercent) {
            const factor = 100 / sum;
            tabQte = tabQte.map(value => value * factor);
        }
        // console.log({ tabTheme, colorTab, tabQte });
        
        return { tabTheme, colorTab, tabQte };
        
        // function getDataSource() {
        //     return grapheType.value === 'tiers' 
        //         ? tiersTable.value
        //         : axe.value.source === 'GLOBAL'
        //             ? statsTable.value
        //             : statsTableFiltred.value;
        // }
        
        function generateRandomColor() {
            return '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16).padStart(6, '0');
        }
    } 
    
    watch(
        axe,
        (newValue, oldValue) => {
            chartData2()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
async  function getPhotos (el){

    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getphoto',
    headers: { 
        'Content-Type': 'application/json'
    },
    params : {photo:el}
    }

    return axios.request(config)
    .then((response) => { 
        srcImage.value=response.data
        imageDialog.value=true;
        
    })
    .catch((error) => {
    console.log(error);
    });
}

async  function validerReception(){

    termine.value=true
    let data = {...bonReception.value,termine:termine.value}
    store.commit('terminerReception',data)   
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/recordsfripe',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => {    
    })
    .catch((error) => {
    console.log(error);
    });
 }
 async function reSendEmail(){

    dialogEmail.value=true
    let data = {...bonReception.value,attente:attente.value}
        
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/resendemail',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }

    return axios.request(config)
    .then((response) => { 

    })
    .catch((error) => {
    console.log(error);
    });
}



onMounted(()=>{
    getReceptions()
})


</script>
<style>
.photo {
    color:blue;
    cursor: pointer;
}
.photo:hover{
    background-color: lightgrey
}
</style>